import { NgModule } from '@angular/core';
import { CapitalizePipe } from './capitalize.pipe';
import { AzureTokenBlobPipe } from './azureBlobToken.pipe';
import { PcapitalizePipe } from './pcapitalize.pipe';
import { SplitPipe } from './split.pipe';
import { AzureFolderNamePipe } from './azureFolderName.pipe';
import { CustDateMediumPipe, ReasonMessagePipe } from './cust-date-medium.pipe';
import { CustomAgileCurrency, CustomAgileShortHand, CustomAgileShortHandCurrency } from './customAgilecurrency.pipe';
import { FilterCheckoutPipe } from './filter-checkout.pipe';
import { PhoneNumberFormat } from './phoneNumberFormat.pipe';
import { PhoneFormaterPipe } from './phoneFormat.pipe';
import { KeysPipe } from './keys.pipe';
import { CalDateFormatPipe } from './calDateFormat.pipe';
import { OfferfilterPipe } from './offerfilter.pipe';
import {
  CustDayNamePipe,
  CustDayNameChangePipe,
  custCalDayNamePipe,
  CustCalDayNameChangePipe,
  custCalMonthNamePipe,
  CustCalMonthPipe,
  dateTimePipe,
  CountryFilter,
  BookingStatus,
  CustomPluralPipe,
  CustomAgileDate,
  CustWeekNamePipe,
  CustomDateEnhancePipe,
  CustTimeZone,
  CustDateAndTime,
} from './customAgileDate.pipe';
import {
  momentPipeDateTime,
  momentPipeDate,
  MomentPipeDateChange,
  MultiLangDatePipe,
  seatMomentPipeDateTime,
  CustTimePipe,
  CustTimePipeChange,
  GetDayPipe,
  RoomOrder,
  SafePipe,
  custTimeGroup,
  checkDate,
  EscapeHtmlPipe,
  TherapistNamePipe,
  SpaServiceFilter,
  ChunkService,
  ServiceGroupFilter,
  checkObjEmpty,
  SeatTimePipe,
  ActivityTimeFormatPipe,
  GroupByProductPipe,
  NightsBetweenPipe,
  DurationBetweenPipe,
  SafeHtmlPipe,
  GroupByDatePipe,
  ActivityAndCartItemsPipe,
  SecondsTransformPipe,
  CalculateStartingFromRate,
  CalcTotalPriceByKey,
  CheckForAddedItem,
  GuestCountBasedRate,
  ImplodePipe,
} from './format.pipe';
import { EnclosePipe } from './enclose.pipe';

@NgModule({
  declarations: [
    CapitalizePipe,
    AzureTokenBlobPipe,
    PcapitalizePipe,
    SplitPipe,
    AzureFolderNamePipe,
    CustDateMediumPipe,
    CustTimeZone,
    CustDateAndTime,
    ReasonMessagePipe,
    CustomAgileCurrency,
    CustDayNamePipe,
    CustDayNameChangePipe,
    custCalDayNamePipe,
    CustCalDayNameChangePipe,
    custCalMonthNamePipe,
    CustCalMonthPipe,
    dateTimePipe,
    CountryFilter,
    BookingStatus,
    CustomPluralPipe,
    CustomAgileDate,
    FilterCheckoutPipe,
    PhoneNumberFormat,
    momentPipeDateTime,
    momentPipeDate,
    MomentPipeDateChange,
    MultiLangDatePipe,
    seatMomentPipeDateTime,
    CustTimePipe,
    CustTimePipeChange,
    GetDayPipe,
    RoomOrder,
    SafePipe,
    custTimeGroup,
    checkDate,
    EscapeHtmlPipe,
    TherapistNamePipe,
    SpaServiceFilter,
    ChunkService,
    ServiceGroupFilter,
    checkObjEmpty,
    SeatTimePipe,
    ActivityTimeFormatPipe,
    GroupByProductPipe,
    NightsBetweenPipe,
    DurationBetweenPipe,
    SafeHtmlPipe,
    GroupByDatePipe,
    ActivityAndCartItemsPipe,
    PhoneFormaterPipe,
    KeysPipe,
    CalDateFormatPipe,
    OfferfilterPipe,
    CustWeekNamePipe,
    SecondsTransformPipe,
    CalculateStartingFromRate,
    CalcTotalPriceByKey,
    CheckForAddedItem,
    GuestCountBasedRate,
    CustomDateEnhancePipe,
    EnclosePipe,
    ImplodePipe,
  ],
  exports: [
    CapitalizePipe,
    AzureTokenBlobPipe,
    PcapitalizePipe,
    SplitPipe,
    AzureFolderNamePipe,
    CustDateMediumPipe,
    CustTimeZone,
    CustDateAndTime,
    ReasonMessagePipe,
    CustomAgileCurrency,
    CustDayNamePipe,
    CustDayNameChangePipe,
    custCalDayNamePipe,
    CustCalDayNameChangePipe,
    custCalMonthNamePipe,
    CustCalMonthPipe,
    dateTimePipe,
    CountryFilter,
    BookingStatus,
    CustomPluralPipe,
    CustomAgileDate,
    FilterCheckoutPipe,
    PhoneNumberFormat,
    momentPipeDateTime,
    momentPipeDate,
    MomentPipeDateChange,
    MultiLangDatePipe,
    seatMomentPipeDateTime,
    CustTimePipe,
    CustTimePipeChange,
    GetDayPipe,
    RoomOrder,
    SafePipe,
    custTimeGroup,
    checkDate,
    EscapeHtmlPipe,
    TherapistNamePipe,
    SpaServiceFilter,
    ChunkService,
    ServiceGroupFilter,
    checkObjEmpty,
    SeatTimePipe,
    ActivityTimeFormatPipe,
    GroupByProductPipe,
    NightsBetweenPipe,
    DurationBetweenPipe,
    SafeHtmlPipe,
    GroupByDatePipe,
    ActivityAndCartItemsPipe,
    PhoneFormaterPipe,
    KeysPipe,
    CalDateFormatPipe,
    OfferfilterPipe,
    CustWeekNamePipe,
    SecondsTransformPipe,
    CalculateStartingFromRate,
    CalcTotalPriceByKey,
    CheckForAddedItem,
    GuestCountBasedRate,
    CustomDateEnhancePipe,
    EnclosePipe,
    ImplodePipe,
  ],
  providers: [
    CapitalizePipe,
    AzureTokenBlobPipe,
    PcapitalizePipe,
    SplitPipe,
    AzureFolderNamePipe,
    CustDateMediumPipe,
    CustTimeZone,
    CustDateAndTime,
    ReasonMessagePipe,
    CustomAgileCurrency,
    CustDayNamePipe,
    CustDayNameChangePipe,
    custCalDayNamePipe,
    CustCalDayNameChangePipe,
    custCalMonthNamePipe,
    CustCalMonthPipe,
    dateTimePipe,
    CountryFilter,
    BookingStatus,
    CustomPluralPipe,
    CustomAgileDate,
    FilterCheckoutPipe,
    PhoneNumberFormat,
    momentPipeDateTime,
    momentPipeDate,
    MomentPipeDateChange,
    MultiLangDatePipe,
    seatMomentPipeDateTime,
    CustTimePipe,
    CustTimePipeChange,
    GetDayPipe,
    RoomOrder,
    SafePipe,
    custTimeGroup,
    checkDate,
    EscapeHtmlPipe,
    TherapistNamePipe,
    SpaServiceFilter,
    ChunkService,
    ServiceGroupFilter,
    checkObjEmpty,
    SeatTimePipe,
    ActivityTimeFormatPipe,
    GroupByProductPipe,
    NightsBetweenPipe,
    DurationBetweenPipe,
    SafeHtmlPipe,
    GroupByDatePipe,
    ActivityAndCartItemsPipe,
    PhoneFormaterPipe,
    KeysPipe,
    CalDateFormatPipe,
    OfferfilterPipe,
    CustWeekNamePipe,
    SecondsTransformPipe,
    CalculateStartingFromRate,
    CalcTotalPriceByKey,
    CheckForAddedItem,
    GuestCountBasedRate,
    CustomDateEnhancePipe,
    EnclosePipe,
    ImplodePipe,
    CustomAgileShortHand,
    CustomAgileShortHandCurrency,
  ],
})
export class CommonPipesModule {}
